




import { Vue, Component } from 'vue-property-decorator'
import { Main } from './components/index'
@Component({
  components: {
    Main,
  },
})
export default class Planning extends Vue {}
